// @flow
// $FlowFixMe
import React, { memo } from "react";
import { get, cloneDeep, noop } from "lodash";
import type { RaceProgram, RaceListItem } from "@tvg/types/Race";
import type { UnaryFn } from "@tvg/types/Functional";
import buildColor from "@fdr/static-ui/ColorPalette";
import Icon from "@fdr/static-ui/Icons";
import { arrowRight, promo } from "@fdr/static-ui/Icons/icons";

import MTP from "../../_atoms/MTP";
import RaceInfoInline from "../../_atoms/RaceInfoInline";

import {
  RaceSelectorListItem,
  RaceSelectorLink,
  RaceSelectorInfo,
  RaceNumberPromo,
  RaceNumber,
  Highlighted,
  Promo
} from "./styled-components";

type Props = {
  race: RaceProgram,
  raceData: ?(RaceListItem[]),
  isLogged: boolean,
  changeRace: UnaryFn<number, void>
};

const bestPromo = ({ allowBelowTheLine, promos }) => {
  let belowTheLinePromo;
  let aboveTheLinePromo;
  promos.forEach((promotion) => {
    if (!promotion.isAboveTheLine && !belowTheLinePromo && allowBelowTheLine) {
      belowTheLinePromo = cloneDeep(promotion);
    }

    if (promotion.isAboveTheLine && !aboveTheLinePromo) {
      aboveTheLinePromo = cloneDeep(promotion);
    }
  });
  return belowTheLinePromo || aboveTheLinePromo;
};

const RaceSelectorItem = memo((props: Props) => {
  const { race, raceData, isLogged, changeRace } = props;

  const racePromo = bestPromo({
    allowBelowTheLine: isLogged,
    promos: get(race, "promos", [])
  });
  const userPromo = bestPromo({
    allowBelowTheLine: isLogged,
    promos: get(race, "userPromotions", [])
  });

  const hasPromo =
    get(racePromo, "isAboveTheLine", false) ||
    !!get(racePromo, "promoPath", "") ||
    !!userPromo;
  const isOptedIn =
    get(userPromo, "isOptedIn", false) || get(racePromo, "isOptedIn", false);

  let promoState = "no promo";
  if (hasPromo || userPromo) {
    promoState = isOptedIn ? "promo optin" : "promo";
  }

  const raceUrl = `${window.location.pathname}?race=${+race.raceNumber}`;

  return (
    <RaceSelectorListItem>
      <RaceSelectorLink
        to={raceUrl}
        onClick={() => changeRace(+race.raceNumber)}
      >
        <RaceSelectorInfo>
          <MTP
            mtp={race.mtp}
            status={get(race, "status.code")}
            postTime={race.postTime}
            isSmall
            isNewLayout
            showDescription={false}
            mode="light"
          />
          <RaceNumberPromo>
            <RaceNumber>
              {race.highlighted && race.highlighted.style === "Highlighted" && (
                <Highlighted>{race.highlighted.description}</Highlighted>
              )}
              Race {race.raceNumber}
            </RaceNumber>
            {promoState !== "no promo" && (
              <Promo className={promoState}>
                <Icon icon={promo} size={16} />
                Promo
              </Promo>
            )}
          </RaceNumberPromo>
          <RaceInfoInline
            raceData={raceData}
            textColor={buildColor("grey", "800")}
          />
        </RaceSelectorInfo>
        <Icon icon={arrowRight} color={buildColor("blue", "500")} size={24} />
      </RaceSelectorLink>
    </RaceSelectorListItem>
  );
});

RaceSelectorItem.defaultProps = {
  race: null,
  raceData: [],
  isLogged: false,
  changeRace: noop
};

export default RaceSelectorItem;
